// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartFilled: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.499" height="12">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M10.854 9.75c-.621 0-1.104.504-1.104 1.125A1.12 1.12 0 0 0 10.854 12c.6 0 1.104-.504 1.104-1.125s-.462-1.125-1.104-1.125Zm-6.75 0C3.483 9.75 3 10.254 3 10.875A1.12 1.12 0 0 0 4.104 12c.6 0 1.104-.504 1.104-1.125S4.746 9.75 4.104 9.75Zm9.244-8.702a.744.744 0 0 0-.6-.298h-9.91L2.803.457A.564.564 0 0 0 2.25 0H.541A.554.554 0 0 0 0 .541c0 .29.252.584.541.584h1.222l1.413 7.418A.605.605 0 0 0 3.75 9h7.688c.31 0 .562-.252.562-.541a.566.566 0 0 0-.562-.584H4.216L4.001 6.75h7.462a.75.75 0 0 0 .721-.544l1.286-4.479a.777.777 0 0 0-.122-.679Z"
            />
        </svg>
    );
};

export default React.memo(CartFilled);
